export function groupBy(arr, property)
{
    return arr.reduce(function (newArr, x) {
        if (!newArr[x[property]]) {
            newArr[x[property]] = []
        }
        newArr[x[property]].push(x)
        return newArr
    }, {})
}
